<template>
  <div class="navi">
    <span v-if="disabledPrevYear" class="pager-arw prev is-disabled"></span>
    <Button v-else flat class="pager-arw prev" @click="selectYearData(selectedYear, 'prev')">
      前月
    </Button>
    <Button flat class="selected-year" @click="toggleYearList">
      <span class="year">{{ selectedYear }}年</span>
    </Button>
    <span v-if="disabledNextYear" class="pager-arw next is-disabled"></span>
    <Button v-else flat class="pager-arw next" @click="selectYearData(selectedYear, 'next')">
      翌月
    </Button>
    <div class="year-list" v-show="isShowYearList">
      <div id="list">
        <ul v-for="yearAry in yearList" :key="yearAry.key">
          <li>
            <button
              :class="{ selected: yearAry === selectedYear, is_this_year: yearAry === isThisYear }"
              @click="selectYearData(yearAry, 'this')"
            >
              <span class="item"
                ><em>{{ yearAry }}</em
                >年</span
              >
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { scrollIntoView } from '@/utils'
import Button from '@/components/atoms/Button'

export default {
  name: 'YearNavi',
  components: {
    Button,
  },
  props: {
    selectedYear: Number,
  },
  data() {
    return {
      isShowYearList: false,
      isThisYear: new Date().getFullYear(),
    }
  },
  computed: {
    disabledPrevYear() {
      return `${this.selectedYear}` <= '2018'
    },
    disabledNextYear() {
      return `${this.selectedYear}` >= this.isThisYear
    },
    yearList() {
      const list = []
      const n = this.isThisYear - 2018
      for (let i = 0; i <= n; i++) {
        list.push(i + 2018)
      }
      return list
    },
  },
  methods: {
    selectYearData(year, type) {
      if (type === 'this') this.$emit('createYearData', year)
      if (type === 'prev') this.$emit('createYearData', year - 1)
      if (type === 'next') this.$emit('createYearData', year + 1)
      this.isShowYearList = false
    },
    toggleYearList() {
      if (this.isShowYearList) {
        this.isShowYearList = false
      } else {
        this.isShowYearList = true
        // 選択年にスクロール
        this.$nextTick(() => {
          const el = document.getElementsByClassName('selected')[0]
          scrollIntoView(el, { behavior: 'instant', block: 'start', inline: 'nearest' })
        })
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.navi {
  align-items: center;
  background-color: var(--white);
  border-radius: 16px;
  display: flex;
  height: 32px;
  justify-content: space-between;
  justify-self: center;
  margin-top: 18px;
  position: relative;
  width: 290px;
}

.year-list {
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 32px;
  width: 256px;
  z-index: 10;

  &::before,
  &::after {
    border-style: solid;
    border-width: 0 16px 16px;
    content: '';
    height: 0;
    left: 45%;
    position: absolute;
    width: 0;
  }

  &::before {
    border-color: transparent transparent var(--border-color) transparent;
    top: 0;
  }

  &::after {
    border-color: transparent transparent var(--white);
    top: 1px;
  }

  > div {
    background-color: var(--white);
    border: 1px solid var(--border-color);
    border-radius: 4px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    margin-top: 16px;
    -webkit-overflow-scrolling: touch;
    overflow-x: hidden;
    overflow-y: scroll;
    width: 256px;
  }

  li {
    position: relative;
  }

  button {
    appearance: none;
    background-color: transparent;
    border: 0;
    border-radius: 0;
    color: var(--text-color);
    cursor: pointer;
    font-family: inherit;
    font-size: 21px;
    font-weight: bold;
    height: 63px;
    outline: none;
    padding: 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    width: 256px;

    > .item {
      display: inline-block;
      font-size: 21px;
      margin-right: 8px;
      text-align: right;
    }

    em {
      font-size: 32px;
      font-style: normal;
      padding-right: 8px;
    }

    &::after {
      background-color: var(--border-color);
      bottom: 0;
      content: '';
      height: 1px;
      left: 8px;
      position: absolute;
      width: 240px;
    }

    &.selected {
      background-color: var(--very-light-yellow);
    }

    &.is_this_year {
      &::before {
        background-color: var(--very-dark-gray);
        border-radius: 8px;
        color: var(--white);
        content: '今年';
        display: block;
        font-size: 13px;
        font-weight: normal;
        height: 16px;
        line-height: 1.3;
        position: absolute;
        right: 23px;
        text-align: center;
        top: 23px;
        width: 40px;
      }
    }
  }

  ul:last-child li:last-child button::after {
    display: none;
  }
}

.pager-arw {
  display: block;
  height: 24px;
  padding: 0;
  position: relative;
  text-indent: -9999px;
  width: 24px;

  &::before {
    border-right: 2px solid var(--brand-color);
    border-top: 2px solid var(--brand-color);
    bottom: 0;
    content: '';
    height: 7px;
    left: 9px;
    margin: auto;
    position: absolute;
    top: 0;
    width: 7px;
  }

  &.prev {
    margin-left: 12px;

    &::before {
      transform: rotate(-135deg);
    }
  }

  &.next {
    margin-right: 12px;

    &::before {
      transform: rotate(45deg);
    }
  }

  &.is-disabled::before {
    border-right: 2px solid var(--dark-gray);
    border-top: 2px solid var(--dark-gray);
  }
}

.selected-year {
  color: var(--very-dark-gray-2);
  font-weight: normal;
  height: 32px;
  line-height: 1.6;

  .year {
    box-sizing: border-box;
    font-size: 21px;
    font-weight: bold;
    padding-right: 8px;
    position: relative;
    text-align: right;
    width: 94px;

    &::after {
      border: 5px solid transparent;
      border-left: 5px solid var(--very-dark-gray-2);
      box-sizing: border-box;
      content: '';
      height: 5px;
      position: absolute;
      right: -16px;
      top: 14px;
      transform: rotate(90deg);
      width: 5px;
    }
  }
}
</style>
